import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeInRightAnimation } from '../../../@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from '../../../@fury/animations/scale-in.animation';
import { fadeInUpAnimation } from '../../../@fury/animations/fade-in-up.animation';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Params } from '@angular/router';
import { LayoutService } from '../../layout/layout.service';
import { PublicNotificationsService } from '../../services/configuration/public-notifications.service';
import { PublicNotification } from '../../interfaces/configuration/public-notification';
import { AuthenticationService } from '../../services/base/authentication.service';

@Component({
  selector: 'fury-public-notifications',
  templateUrl: './public-notifications.component.html',
  styleUrls: ['./public-notifications.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class PublicNotificationsComponent implements OnInit, OnDestroy {

  public publicNotification: PublicNotification = null;
  public isLoading: boolean = true;

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private activatedRoute: ActivatedRoute,
              private layoutService: LayoutService,
              private publicNotificationsService: PublicNotificationsService,
              public authenticationService: AuthenticationService,
  ) {
  }

  ngOnInit(): void {
    this.layoutService.isPublicNotificationVisible.emit(true);

    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params: Params): void => {
      if (typeof params['url'] !== 'undefined') {
        if (params['url'] !== null && params['url'] !== '') {
          this.publicNotificationsService.get(params['url']).pipe(takeUntil(this.destroy$))
            .subscribe((data: PublicNotification): void => {
                if (data) {
                  this.publicNotification = data;
                }

                this.isLoading = false;
              },
              (): boolean => this.isLoading = false
            );
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
